export const environment = {
    "configuration": "DEBUG",
    "production": false,
    "log_level": "Debug",
    "print_logs": true,
    type: 'stage',
    "tones": {
        "default": {
            "ATTACH-DOCUMENT-TONE": " Answer the following question using only the data provided in the 'Sources' section of message. Your answer can't include assumptions and other sources rather than information from message.",
            "formal": "\nYou are 'R2 Copilot' - an intelligent assistant.\nThe writing style is formal.",
            "informal": "\nYou are 'R2 Copilot' - an intelligent assistant.\nThe writing style is informal."
        },
        "-1008236542": {
            "ATTACH-DOCUMENT-TONE": " Ответьте на следующий вопрос, используя только данные, указанные в разделе «Sources» сообщения. Ваш ответ не может включать предположения и другие источники, а не информацию из сообщения.",
            "formal": "\nТы - 'R2 Copilot' ИИ помощник анализирующий документы компании и предоставлюящий результаты поиска по ним.\nСтиль написания - формальный.",
            "informal": "\nТы - 'R2 Copilot' ИИ помощник анализирующий документы компании и предоставлюящий результаты поиска по ним.\nСтиль написания - неформальный."
        }
    },
    "quick_actions": {
        "default": [
            {
                title: "Proofread",
                value: "Proofread",
            },
            {
                title: "Rephrase",
                value: "Rephrase",
            },
            {
                title: "Expand",
                value: "Expand",
            },
            {
                title: "Make shorter",
                value: "Make shorter",
            },
            {
                title: "Translate to English",
                value: "Translate to English",
            },
            {
                title: "Make summary",
                value: "Make summary",
            }
        ],
        "Excel": [
            {
                title: "Write the numbers in text form",
                value: "Write the numbers in text form",
            },
            {
                title: "Sum all even/odd/positive/negative numbers",
                value: "Sum all even/odd/positive/negative numbers",
            },
            {
                title: "Write a list of days of the week/months",
                value: "Write a list of days of the week/months",
            },
            {
                title: "Calculate the average value of the numbers",
                value: "Calculate the average value of the numbers"
            },
        ],
        "Word": [
            {
                title: "Count words/lines/characters",
                value: "Count words/lines/characters"
            },
            {
                title: "Correct spelling",
                value: "Correct spelling"
            },
            {
                title: "Improve style",
                value: "Improve style"
            },
            {
                title: "Create a summary",
                value: "Create a summary"
            },
            {
                title: "Translate to English",
                value: "Translate to English"
            },
        ],
        "PowerPoint": [
            {
                title: "Break the text into bullet points",
                value: "Break the text into bullet points"
            },
            {
                title: "Rewrite the text concisely",
                value: "Rewrite the text concisely"
            },
            {
                title: "Suggest animation for an element",
                value: "Suggest animation for an element"
            },
            {
                title: "Suggest a chart type for the data",
                value: "Suggest a chart type for the data"
            },
            {
                title: "Suggest a prompt for creating an image",
                value: "Suggest a prompt for creating an image"
            },
        ],
    },
    "prompts_divider": 800,
    "limits_bytes": {
        "TONE":             700,
        "SEND_MESSAGE":     29000,
        "ATTACH_SELECTED":  29000,
        "ATTACH_DOCUMENT":  29000,
        "ATTACH_HISTORY":   29000,
        "WHOLE_MESSAGE":    58000,
        "QUICK_ACTIONS":    160,
    },
    history_count_message: 2,
    office_api_host: 'https://ai-office-addin-stage.azurewebsites.net',
    default_locale: 'en',
    redirect_path_name: '/auth/callback',
    db: {
        name: 'r2-copilot',
        version: 1,
    },
    input_action_polling_interval_in_ms: 1000,
    animation_delay_in_ms: {
        trigger: 120,
    },
    office_core_version: 1,
};
